import {Component, Input} from '@angular/core';
import {CompetitorLiveResults, LiveResult} from 'src/app/model/live-results';

@Component({
  selector: 'app-live-results-mobile-item',
  templateUrl: './live-results-mobile-item.component.html',
  styleUrls: ['./live-results-mobile-item.component.scss']
})
export class LiveResultsMobileItemComponent {
  @Input() hasBorderBottom: boolean = true;
  @Input() liveResult?: CompetitorLiveResults = undefined;

}
